import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { CaretDoubleUp, DotsThree, Notepad } from "@phosphor-icons/react";
import { useState } from "react";
function formatMessage(message) {
    return message.replace(/\r\n|\n/g, '<br />');
}
const Message = ({ message, name, date, maxCharacters, contractId, }) => {
    const [showFullText, setShowFullText] = useState(false);
    const appUrl = process.env.REACT_APP_APPLICATION_BASE_URL;
    const toggleTextVisibility = () => {
        setShowFullText(!showFullText);
    };
    const truncatedText = showFullText
        ? message
        : message.slice(0, maxCharacters);
    return (_jsxs(Grid, { container: true, size: 12, className: "rightmessage", sx: {
            alignItems: "center"
        }, children: [_jsx(Grid, { size: 1, children: _jsx(Notepad, { size: 32 }) }), _jsxs(Grid, { container: true, size: 12, className: "content", children: [_jsxs(Grid, { className: "namecontainer", children: [_jsx(Typography, { className: "nametext", children: name === "Offertepagina bekeken" ||
                                    name === "Offerte afgewezen" ||
                                    name === "Offerte verzonden" ? (_jsx("a", { href: contractId && contractId != null
                                        ? appUrl + "contract?contractId=" + contractId
                                        : "#", target: "_blank", children: name })) : (_jsx(_Fragment, { children: name })) }), _jsx(Typography, { className: "datetext", children: date })] }), _jsxs(Grid, { children: [_jsx(Typography, { className: "message", dangerouslySetInnerHTML: { __html: formatMessage(truncatedText) } }), message.length > maxCharacters &&
                                (showFullText ? (_jsx(CaretDoubleUp, { onClick: toggleTextVisibility, children: " " })) : (_jsx(DotsThree, { onClick: toggleTextVisibility })))] })] })] }));
};
export default Message;
